import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'r2b_referrals-click_on_promo_banner-click';

/**
 * Tracks clicks on the CTA in the promo banner at the top that promotes the R2B referrals
 */
export function trackR2BReferralsClickOnPromoBannerClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
